import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import { setEditCrashCourseBatchModalState } from 'features/classCreation';
import styles from './ConfimModalCloseButton.module.scss';

function ConfimModalCloseButton() {
  const dispatch = useDispatch();

  const handleOnClick = useCallback(() => {
    dispatch(setEditCrashCourseBatchModalState(false));
  }, [dispatch]);

  return (
    <Tappable
      className={classNames(
        'btn btn-outlined btn-primary m-l-xxs',
        styles.root
      )}
      onClick={handleOnClick}
    >
      No
    </Tappable>
  );
}

export default ConfimModalCloseButton;
